import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import LanguageStrings from '../../../i18n/locales'

export interface assetDeleteState {
  isLoading: boolean
  error: string | undefined
  assetDeleteData: string | undefined
  httpStatus: number | undefined
}

export const initialState: assetDeleteState = {
  isLoading: true,
  error: undefined,
  assetDeleteData: undefined,
  httpStatus: 0
}

const AssetManagementStrings =
    LanguageStrings().AssetManagementCollectionStrings.TableComponent

const assetDeleteSlice = createSlice({
  name: 'assetDelete',
  initialState,
  reducers: {
    assetDeleteLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        assetDeleteData: undefined,
        httpStatus: 0
      }
    },
    assetDeleteUpdateAction: (state, action: PayloadAction<{ data: any, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: undefined,
        assetDeleteData: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    assetDeleteErrorAction: (state, action: PayloadAction<{ errorMessage: string | undefined, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage ?? AssetManagementStrings.NetworkError,
        assetDeleteData: undefined,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  assetDeleteLoadingAction,
  assetDeleteUpdateAction,
  assetDeleteErrorAction
} = assetDeleteSlice.actions

export default assetDeleteSlice.reducer
